<div>
  <div>
    An S3 bucket already exists with name "{{ recoveryBucketName }}". Please configure a custom recovery bucket suffix
    for this bucket below, or configure an alternate
    <a href="{{ accountResourceConfigUrl }}">account-level default suffix</a>, then try again.
  </div>

  <form [formGroup]="configFormModel" (ngSubmit)="saveClick()" class="form-controls">
    <div class="flex-center-row control-header">
      <input
        type="text"
        formControlName="recoveryBucketSuffix"
        [placeholder]="defaultSuffix"
        class="arpio-input"
        minlength="2"
        maxlength="12"
      />
      <button type="submit" class="arpio-button margin-left" [disabled]="!validConfig">
        @switch (saveStatus) {
          @case ('saving') {
            <i class="fa-solid fa-spinner fa-spin"></i>
          }
          @case ('saved') {
            <i class="fa-utility fa-semibold fa-check"></i>
          }
          @default {
            SAVE
          }
        }
      </button>
    </div>
    <div class="new-bucket-name">
      <span class="new-bucket-name-label">New recovery bucket name:</span>
      {{ newRecoveryBucketName }}
    </div>
  </form>
</div>
